import React from 'react';

import { useRouter } from 'next/router';

import useHasFeature from '../../../shared/utils/useHasFeature';
import { EqualWebSnippet } from '../../../techstyle-shared/react-components';
import { useSession } from '../../../techstyle-shared/redux-core';
import featureNames from '../../constants/featureFlags';

function AccessibilitySnippet() {
  const isProd = process.NODE_ENV === 'production';
  const { isAdmin, isLoggedIn } = useSession();
  const router = useRouter();
  const { query } = router;
  const { enabled: accessibilityFF } = useHasFeature(
    featureNames.ACCESSIBILITY_AI_WIDGET
  );
  const enableADAWidget = !isLoggedIn && accessibilityFF;
  const enableSnippet = (isProd && !isAdmin) || (!isProd && !query?.admin);

  if (enableADAWidget && enableSnippet) {
    return <EqualWebSnippet />;
  } else if (typeof window !== 'undefined') {
    // Remove floating widget button if it was set.
    // We want to have the floating button only for logged out users, logged in users
    // will have the button in the footer instead (see AdaWidget component).
    // interdeal is the global equalweb object. INDmenu-btn is the floating button.
    const equalwebWidget = window.interdeal?.INDWrap;
    if (equalwebWidget) {
      const menuBtn = equalwebWidget.querySelector('#INDmenu-btn');
      if (menuBtn) {
        menuBtn.remove();
      }
    }
  }

  return null;
}

AccessibilitySnippet.propTypes = {};

export default AccessibilitySnippet;
